/* Aurora wishlist — localStorage favorites. No app, no login, no extra requests.
   Stores a small record per product so the Favorites page renders instantly. */
(function () {
  var KEY = 'aurora:wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('aurora:wishlist:change', { detail: { list: list } }));
  }

  function has(list, id) {
    return list.some(function (it) { return String(it.id) === String(id); });
  }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-wish-id'),
      handle: btn.getAttribute('data-wish-handle'),
      url: btn.getAttribute('data-wish-url'),
      title: btn.getAttribute('data-wish-title'),
      image: btn.getAttribute('data-wish-image'),
      price: btn.getAttribute('data-wish-price')
    };
  }

  function toggle(btn) {
    var list = read();
    var id = btn.getAttribute('data-wish-id');
    if (has(list, id)) {
      list = list.filter(function (it) { return String(it.id) !== String(id); });
    } else {
      list.push(itemFromButton(btn));
    }
    write(list);
  }

  /* reflect saved state on every heart + update header counts */
  function sync() {
    var list = read();
    document.querySelectorAll('[data-aurora-wish]').forEach(function (btn) {
      var on = has(list, btn.getAttribute('data-wish-id'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-aurora-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-visible', list.length > 0);
    });
    // header heart: mark when there's anything saved (for the "fill the icon" mode)
    document.querySelectorAll('.header__icon--wishlist').forEach(function (el) {
      el.classList.toggle('has-items', list.length > 0);
    });
  }

  /* Favorites page: build cards from stored records */
  function renderPage() {
    var grid = document.querySelector('[data-aurora-wish-list]');
    if (!grid) return;
    var empty = document.querySelector('[data-aurora-wish-empty]');
    var list = read();

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    grid.innerHTML = list.map(function (it) {
      // same treatment as the drawer: request a thumbnail rather than the master, and let
      // healImages() repair anything missing or dead from the product's own JSON
      var img = '<img src="' + esc(sized(it.image, CARD_W)) + '" alt="" class="aurora-card__img"' +
                ' loading="lazy" decoding="async" data-wish-heal="' + esc(it.url) + '">';
      return '' +
        '<li class="aurora-wish__item">' +
          '<div class="aurora-card aurora-card--align-left">' +
            '<div class="aurora-card__media" style="--ar: var(--awd-ar, 1);">' +
              '<a href="' + it.url + '" class="aurora-card__media-link" tabindex="-1">' + img + '</a>' +
              '<button type="button" class="aurora-card__wish is-active" aria-label="' + esc(WISH_STR('remove','Remove from favorites')) + '" aria-pressed="true"' +
                ' data-aurora-wish data-wish-id="' + it.id + '" data-wish-handle="' + (it.handle || '') + '"' +
                ' data-wish-url="' + it.url + '" data-wish-title="' + (it.title || '').replace(/"/g, '&quot;') + '"' +
                ' data-wish-image="' + (it.image || '') + '" data-wish-price="' + (it.price || '') + '">' +
                (window.AuroraHeartSVG || '') +
              '</button>' +
            '</div>' +
            '<div class="aurora-card__info">' +
              '<a href="' + it.url + '" class="aurora-card__title card__heading">' + (it.title || '') + '</a>' +
              '<div class="aurora-card__price">' + (it.price || '') + '</div>' +
              '<button type="button" class="aurora-wish__add aurora-btn aurora-btn--fill"' +
                ' data-aurora-quickbuy-open data-product-url="' + esc(it.url) + '">' +
                esc(WISH_STR('addToCart','Add to cart')) +
              '</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    }).join('');
    healImages(grid);
  }

  /* ---- drawer -------------------------------------------------------------
     Follows the theme drawer convention (see the cart / search / quick-buy drawers):
     scrim + panel lifted to <body>, `is-open` toggled, closes on the X, the scrim,
     Escape and an outside click. Items are drawn from localStorage, so the drawer is
     correct the moment it opens and after any change in this tab or another. */
  var DRAWER_LOCK = 'aurora-wish-locked';
  var signinDismissed = false;

  function drawerEl() { return document.querySelector('aurora-wishlist-drawer'); }

  /* The shell is rendered inside header.liquid, and the header section group carries its
     own z-index — which traps the panel in that stacking context, so the announcement bar
     painted OVER the drawer no matter how high its z-index went. Same reason the search
     drawer moves itself; move the whole element (not just its children) so the descendant
     selectors keep matching. */
  function liftDrawer() {
    var root = drawerEl();
    if (root && root.parentElement !== document.body) document.body.appendChild(root);
  }


  /* Shopify CDN URLs take a width param. /products/<handle>.js returns the FULL-SIZE
     original — often 2000px+ and several hundred KB — which is what made healed
     thumbnails slow to appear. Ask for what the 8rem slot actually needs (2x for
     retina) instead of downloading the master. */
  var THUMB_W = 200;   // 8rem drawer thumb at 2x
  var CARD_W  = 600;   // full card on the favourites page
  function WISH_STR(k, fallback) {
    return (window.AuroraWishStrings && window.AuroraWishStrings[k]) || fallback;
  }
  function sized(url, w) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return u;
    u = u.replace(/([?&])width=\d+/, '$1width=' + w);
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderDrawer() {
    var root = drawerEl();
    if (!root) return;
    var list = read();
    var ul = root.querySelector('[data-wish-drawer-list]');
    var empty = root.querySelector('[data-wish-drawer-empty]');
    var countEl = root.querySelector('[data-wish-drawer-count]');
    if (countEl) countEl.textContent = list.length;
    if (!ul) return;

    if (!list.length) {
      ul.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    ul.innerHTML = list.map(function (it) {
      // A stored image URL outlives the product it came from, and older saves predate the
      // current card markup, so it can be missing or dead. Render what we have, then let
      // healImages() repair anything that fails from the product's own JSON.
      var img = '<img src="' + esc(sized(it.image, THUMB_W)) + '" alt="" class="awd__img" decoding="async" width="200" height="200"' +
                ' data-wish-heal="' + esc(it.url) + '">';
      return '' +
        '<li class="awd__item">' +
          '<a class="awd__media" href="' + esc(it.url) + '" tabindex="-1">' + img + '</a>' +
          '<div class="awd__info">' +
            '<a class="awd__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
            (it.variant ? '<p class="awd__variant">' + esc(it.variant) + '</p>' : '') +
            '<p class="awd__price">' + esc(it.price) + '</p>' +
            '<div class="awd__actions">' +
              '<button type="button" class="awd__add aurora-btn aurora-btn--fill"' +
                ' data-aurora-quickbuy-open data-product-url="' + esc(it.url) + '">' +
                esc(window.AuroraWishStrings && window.AuroraWishStrings.addToCart || 'Add to cart') +
              '</button>' +
              '<button type="button" class="awd__remove" data-wish-drawer-remove data-wish-id="' + esc(it.id) + '"' +
                ' aria-label="' + esc(window.AuroraWishStrings && window.AuroraWishStrings.remove || 'Remove') + '">' +
                '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    }).join('');
    healImages(root);
  }


  /* Repair broken/missing thumbnails from /products/<handle>.js and persist the fix, so
     the lookup happens once per stale item rather than on every open. */
  function healImages(root) {
    root.querySelectorAll('img[data-wish-heal]').forEach(function (img) {
      var url = img.getAttribute('data-wish-heal');
      if (!url) return;
      var broken = !img.getAttribute('src') || (img.complete && img.naturalWidth === 0);
      function repair() {
        img.removeAttribute('data-wish-heal');
        fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var src = p && (p.featured_image || (p.images && p.images[0]));
            if (!src) throw new Error('no image');
            img.src = sized(src, THUMB_W);
            var list = read();
            var hit = list.filter(function (i) { return i.url === url; })[0];
            // store the FULL url, not the thumbnail one — the favorites page renders
            // bigger cards and should ask for its own size
            if (hit) { hit.image = src.indexOf('//') === 0 ? 'https:' + src : src; write(list); }
          })
          .catch(function () {
            img.replaceWith(Object.assign(document.createElement('span'),
              { className: 'awd__img awd__img--ph' }));
          });
      }
      if (broken) { repair(); return; }
      img.addEventListener('error', repair, { once: true });
      img.addEventListener('load', function () { img.removeAttribute('data-wish-heal'); }, { once: true });
    });
  }

  function onDocClick(e) {
    var root = drawerEl();
    if (!root) return;
    var panel = root.querySelector('.awd__panel');
    if (panel && panel.contains(e.target)) return;
    if (e.target.closest('[data-aurora-wish-open]')) return;
    closeDrawer();
  }
  function onKey(e) { if (e.key === 'Escape') closeDrawer(); }

  function openDrawer() {
    var root = drawerEl();
    if (!root) return;
    renderDrawer();
    root.classList.add('is-open');
    // slide in on the NEXT frame — see the .is-shown note in aurora-wishlist-drawer.css.
    // Reading offsetWidth forces the reflow that makes the transition run (rAF is
    // unreliable: it throttles in background tabs).
    void root.offsetWidth;
    root.classList.add('is-shown');
    document.documentElement.classList.add(DRAWER_LOCK);
    var x = root.querySelector('[data-awd-close]');
    if (x) x.focus();
    // deferred so the click that opened it does not immediately close it
    setTimeout(function () {
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKey);
    }, 0);
  }

  function closeDrawer() {
    var root = drawerEl();
    if (!root) return;
    root.classList.remove('is-shown');   // slide out first (transform transition)
    root.classList.remove('is-open');
    document.documentElement.classList.remove(DRAWER_LOCK);
    document.removeEventListener('click', onDocClick);
    document.removeEventListener('keydown', onKey);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-aurora-wish-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-awd-close]')) { e.preventDefault(); closeDrawer(); return; }
    var sc = e.target.closest('[data-wish-signin-close]');
    if (sc) {
      e.preventDefault();
      signinDismissed = true;
      var n = sc.closest('[data-wish-signin]');
      if (n) n.hidden = true;
      return;
    }
    var rm = e.target.closest('[data-wish-drawer-remove]');
    if (rm) {
      e.preventDefault();
      var id = rm.getAttribute('data-wish-id');
      write(read().filter(function (it) { return String(it.id) !== String(id); }));
      return;
    }
    // adding to cart hands off to the quick-buy drawer, so close this one first
    if (e.target.closest('.awd__add')) closeDrawer();
  });

  /* delegated click: works for cards present now and ones rendered later */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aurora-wish]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  document.addEventListener('aurora:wishlist:change', function () {
    sync();
    renderPage();
    renderDrawer();
  });

  /* keep tabs in sync */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { sync(); renderPage(); renderDrawer(); }
  });

  function init() { liftDrawer(); sync(); renderPage(); renderDrawer(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-sync after Shopify section reloads in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
